import TasksAPI from 'dashboard/api/tasks';

const state = {
  records: [],
  statuses: [],
  pagination: null,
  // Contadores agregados da API (so quando a tela pede with_counts) e a
  // pagina exatamente como veio, para reconciliar alteracoes locais.
  counts: null,
  countsBaseline: [],
  fetchRequestId: 0,
  notificationsTasks: [],
  todayCount: 0,
  overdueCount: 0,
  uiFlags: { isFetching: false, isCreating: false },
};

const getters = {
  getTasks: $state => $state.records,
  getPagination: $state => $state.pagination,
  getCounts: $state => $state.counts || null,
  getCountsBaseline: $state => $state.countsBaseline || [],
  getStatuses: $state => $state.statuses,
  getNotificationsTasks: $state => $state.notificationsTasks,
  getTodayCount: $state => $state.todayCount,
  getOverdueCount: $state => $state.overdueCount,
  getTasksUIFlags: $state => $state.uiFlags,
};

const actions = {
  async fetch({ commit, state: currentState, rootGetters }, params = {}) {
    const accountId = rootGetters?.getCurrentAccountId;
    commit('START_FETCH');
    const requestId = currentState.fetchRequestId;
    try {
      const { data } = await TasksAPI.list(params);
      if (
        requestId !== currentState.fetchRequestId ||
        rootGetters?.getCurrentAccountId !== accountId
      )
        return data;
      commit('SET_TASKS', data.tasks || []);
      commit('SET_PAGINATION', data.pagination);
      commit('SET_COUNTS', { counts: data.counts, tasks: data.tasks });
      commit('SET_STATUSES', data.statuses || []);
      return data;
    } finally {
      if (requestId === currentState.fetchRequestId) {
        commit('SET_UI_FLAG', { isFetching: false });
      }
    }
  },

  async fetchNotifications({ commit, rootGetters }) {
    const accountId = rootGetters?.getCurrentAccountId;
    const { data } = await TasksAPI.notifications();
    if (rootGetters?.getCurrentAccountId === accountId)
      commit('SET_NOTIFICATIONS', data);
    return data;
  },

  async create({ commit, rootGetters }, payload) {
    const accountId = rootGetters?.getCurrentAccountId;
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await TasksAPI.create(payload);
      if (rootGetters?.getCurrentAccountId === accountId)
        commit('UPSERT_TASK', data);
      return data;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update(_, { id, payload }) {
    const { data } = await TasksAPI.update(id, payload);
    return data;
  },

  async remove({ commit, rootGetters }, id) {
    const accountId = rootGetters?.getCurrentAccountId;
    await TasksAPI.remove(id);
    if (rootGetters?.getCurrentAccountId === accountId)
      commit('REMOVE_TASK', id);
  },

  async complete({ commit, rootGetters }, id) {
    const accountId = rootGetters?.getCurrentAccountId;
    const { data } = await TasksAPI.complete(id);
    if (rootGetters?.getCurrentAccountId === accountId)
      commit('UPSERT_TASK', data);
    return data;
  },

  async reopen({ commit, rootGetters }, id) {
    const accountId = rootGetters?.getCurrentAccountId;
    const { data } = await TasksAPI.reopen(id);
    if (rootGetters?.getCurrentAccountId === accountId)
      commit('UPSERT_TASK', data);
    return data;
  },
};

const mutations = {
  START_FETCH(_state) {
    _state.fetchRequestId += 1;
    _state.uiFlags = { ..._state.uiFlags, isFetching: true };
  },
  SET_PAGINATION(_state, pagination) {
    _state.pagination = pagination;
  },
  SET_COUNTS(_state, { counts, tasks } = {}) {
    _state.counts = counts || null;
    // Copia rasa: a pagina pode ser alterada no lugar depois da busca.
    _state.countsBaseline = counts
      ? (tasks || []).map(task => ({ ...task }))
      : [];
  },
  SET_UI_FLAG(_state, flags) {
    _state.uiFlags = { ..._state.uiFlags, ...flags };
  },
  SET_STATUSES(_state, statuses) {
    _state.statuses = statuses;
  },
  SET_TASKS(_state, tasks) {
    _state.records = tasks;
  },
  SET_NOTIFICATIONS(_state, data) {
    _state.notificationsTasks = data.tasks || [];
    _state.todayCount = data.today_count || 0;
    _state.overdueCount = data.overdue_count || 0;
  },
  UPSERT_TASK(_state, task) {
    const idx = _state.records.findIndex(t => t.id === task.id);
    if (idx >= 0) _state.records.splice(idx, 1, task);
    else _state.records.unshift(task);
  },
  REMOVE_TASK(_state, id) {
    _state.records = _state.records.filter(t => t.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
